/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  FormControl,
  Pagination,
  OverlayTrigger,
  Tooltip,
  Jumbotron,
  Modal,
} from "react-bootstrap";
import {
  GetUsertransactionlist,
  DeleteLead,
  searchLead,
  getOrganizationDataWithoutPagination,
  GetAiaUserList,
} from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import { Link, withRouter } from "react-router-dom";
import ReactTable from "react-table";
import Select from "react-select";

import Switch from "react-bootstrap-switch";
import LoadingSpinner from "views/Components/loadingSpinner";

import Card from "components/Card/Card.jsx";
import SweetAlert from "react-bootstrap-sweetalert";

import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
class viewLead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lead_detail: [],
      category: [],
      statusdisplayid: "3",
      name: "",
      email: "",
      lead_catalogue_package: [],
      catalogue_package: [],
      title: "",
      b2b: [],
      company_name: "",
      updated_at: "",
      mobile_no: "",
      comments: "",
      paginationData: [],
      noRecordFound: false,
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      tabledata: "",
      loading: false,
      alert: null,
      useraccess: "",
      usertrasactionmodal: false,
      usertrasactionmodalData: [],
      organizationList: [],
      organization: null,
      organization_id: "",
      isAiaUserModel: false,
      aiaUserTransactionModalData: [],
      aiaMobileNo: "",
    };
    // this.selectedsubscription = this.selectedsubscription.bind(this);
    this.deletelead = this.deletelead.bind(this);
    this.selectedlead = this.selectedlead.bind(this);
    this.onChange = this.onChange.bind(this);
    this.searchdata = this.searchdata.bind(this);
    // this.searchData = this.searchData.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.closeusertrasactionmodal = this.closeusertrasactionmodal.bind(this);
    this.openusertrasactionmodal = this.openusertrasactionmodal.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
  }
  closeusertrasactionmodal() {
    this.setState({ usertrasactionmodal: false, usertrasactionmodalData: [] });
  }
  openusertrasactionmodal(id) {
    this.setState({ usertrasactionmodal: true });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    GetUsertransactionlist(id, obj).then((res) => {
      if (res.success != false) {
        this.setState({ usertrasactionmodalData: res.data.remainingCredit });
      }
    });
  }

  openusertrasactionmodal(id) {
    this.setState({ usertrasactionmodal: true });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    GetUsertransactionlist(id, obj).then((res) => {
      if (res.success != false) {
        this.setState({ usertrasactionmodalData: res.data.remainingCredit });
      }
    });
  }
  selectedlead(cus) {
    // console.log(cus);
    localStorage.setItem("leadID", JSON.stringify(cus));

    this.props.history.push("/admin/editlead");
  }
  componentDidMount() {
    this.selectstatus(this.state.statusdisplayid);
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({
      useraccess: token.role,
    });
    getOrganizationDataWithoutPagination(obj).then((response) => {
      const organizationList = response.data.map((organization) => ({
        value: organization.id,
        label: organization.company_name,
      }));
      this.setState({
        organizationList,
      });
    });
  }
  searchdata(e) {
    this.setState({ page: "" });
    this.selectstatus(this.state.statusdisplayid);
  }
  resetSearch(e) {
    this.setState(
      {
        name: "",
        email: "",
        mobile_no: "",
        organization: null,
        organization_id: "",
        page: "",
      },
      () => this.selectstatus(this.state.statusdisplayid),
    );
  }
  resetSearchAiaMobile(e) {
    this.setState({ aiaMobileNo: "" });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    GetAiaUserList(obj, "")
      .then((res) => {
        this.setState({ aiaUserTransactionModalData: res.data });
      })
      .catch(() => {});
  }
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    this.searchdata();
  };
  handleAiaMobileNoOnChange = (e) => {
    let searchValue = e.target.value;
    this.setState({
      aiaMobileNo: e.target.value,
    });
    this.getAllAiaUserList(searchValue);
  };
  getAllAiaUserList(searchValue) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    GetAiaUserList(obj, searchValue)
      .then((res) => {
        this.setState({ aiaUserTransactionModalData: res.data });
      })
      .catch(() => {});
  }
  paginationinfo(url, id) {
    this.setState({
      page: url,
    });
    this.selectstatus(id);
  }
  selectstatus(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
    // var id = this.state.statusdisplayid;
    // // console.log(id);
    // getLead(id,obj)
    // .then((response) => {
    //     // console.log(response.data);
    //     this.setState({
    //         lead_detail : response.data.data
    //     })
    // })
    this.setState({
      statusdisplayid: id,
    });
    this.setState({ noRecordFound: false });
    // console.log(this.state.itemcode,this.state.description,this.state.price,this.state.medicationcategory,this.state.commision,this.state.unitprice,this.state.page)
    this.setState({ loading: true }, () => {
      searchLead(
        id,
        this.state.name,
        this.state.mobile_no,
        this.state.email,
        this.state.page,
        this.state.organization_id,
        obj,
      ).then((response1) => {
        var data = response1.data;
        if (data.data.length == 0) {
          this.setState({ noRecordFound: true });
        }
        var $no_pages = [];
        let serach_string = "";
        for (var i = 1; i <= data.last_page; i++) {
          if (serach_string == "") {
            $no_pages.push(i);
          } else {
            $no_pages.push(i);
          }
        }
        if (data.current_page == data.last_page) {
          this.setState({ prevdisabled: null });
          this.setState({ nextdisabled: "1" });
        } else if (data.current_page == 1) {
          this.setState({ nextdisabled: null });
          this.setState({ prevdisabled: "1" });
        } else {
          this.setState({ nextdisabled: null });
          this.setState({ prevdisabled: null });
        }
        if (data.last_page == 1) {
          this.setState({ nextdisabled: 1 });
          this.setState({ prevdisabled: 1 });
        }
        if (data.data.length == 0) {
          $no_pages = [];
          this.setState({ nextdisabled: 1 });
          this.setState({ prevdisabled: 1 });
        }
        this.setState({ currentPage: data.current_page });
        if (data.next_page_url != null) {
          if (serach_string == "") {
            this.setState({
              nextpage: data.next_page_url.substring(
                data.next_page_url.indexOf("?page=") + 1,
              ),
            });
          } else {
            this.setState({
              nextpage: data.next_page_url.substring(
                data.next_page_url.indexOf("?page=") + 1,
              ),
            });
          }
        } else {
          this.setState({ nextpage: "#" });
        }
        if (data.prev_page_url != null) {
          if (serach_string == "") {
            this.setState({
              prevpage: data.prev_page_url.substring(
                data.prev_page_url.indexOf("=") + 1,
              ),
            });
          } else {
            this.setState({
              prevpage: data.prev_page_url.substring(
                data.prev_page_url.indexOf("=") + 1,
              ),
            });
          }
        } else {
          this.setState({ prevpage: "#" });
        }
        this.setState({ paginationData: $no_pages });
        this.setState({
          loading: false,
          lead_detail: data.data,
        });
      });
    });
  }
  addlead() {
    this.props.history.push("/admin/addlead");
  }
  aiaActiveUserModel(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ isAiaUserModel: true });

    GetAiaUserList(obj, this.state.aiaMobileNo)
      .then((res) => {
        this.setState({ aiaUserTransactionModalData: res.data });
      })
      .catch(() => {});
  }

  warningWithConfirmAndCancelMessage(id) {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deletelead(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this Lead Detail !
        </SweetAlert>
      ),
    });
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  deletelead(id) {
    var token = JSON.parse(localStorage.getItem("user"));

    const obj = token.token;

    DeleteLead(id, obj).then(() => {
      // alert('category deleted');
      // window.location.href="#/admin/medication-category";
      this.setState({
        alert: null,
      });
      this.selectstatus(this.state.statusdisplayid);
    });
  }

  getCusLeadCataloguePackageTitle(cus) {
    const cusLeadCataloguePackages = cus.lead_catalogue_package || [];

    const leadCataloguePackage = cusLeadCataloguePackages.find(
      (data) => !!data.is_active,
    );
    if (leadCataloguePackage && leadCataloguePackage.catalogue_package) {
      return leadCataloguePackage.catalogue_package.title;
    }
    return "-";
  }
  getAllPackageTitleRelatedLead(cus) {
    const cusLeadCataloguePackages = cus.lead_catalogue_package || [];
    if (cusLeadCataloguePackages && cusLeadCataloguePackages.length > 0) {
      const leadCataloguePackage = cusLeadCataloguePackages.filter(
        (data) =>
          !!data.catalogue_package &&
          data.is_active === 0 &&
          data.catalogue_package.title !== "BASIC",
      );
      if (leadCataloguePackage.length > 1) {
        const packageTitles = leadCataloguePackage.map((item) => {
          return <p>{item.catalogue_package.title}</p>;
        });
        return packageTitles;
      }
      // return ()
    }
    return null;
  }
  render() {
    const viewCallWorkspace = (
      <Tooltip id="view-call-workspace">View call workspace profile</Tooltip>
    );
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;
    const lead_detail = this.state.lead_detail;
    const category = this.state.category;
    const statusdisplayid = this.state.statusdisplayid;
    let c = 1;
    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col>
              <Card
                content={
                  <React.Fragment>
                    <Row>
                      <div
                        style={{
                          borderRadius: 15,
                          marginLeft: "2%",
                          marginRight: "2%",
                          backgroundColor: "lightgray",
                          padding: 10,
                        }}
                      >
                        <Row
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginBottom: 4,
                          }}
                        >
                          <Col
                            md={2}
                            sm={3}
                            lg={2}
                            xs={2}
                            className="text-right"
                          >
                            <Button
                              className="btn-b2b-b2c-fill btn-size"
                              style={{ color: "#ffffff" }}
                              bsStyle="info"
                              fill
                              onClick={() => this.aiaActiveUserModel()}
                            >
                              AIA User List
                            </Button>
                          </Col>
                          <Col
                            md={2}
                            sm={3}
                            lg={2}
                            xs={2}
                            className="text-right"
                          >
                            <Button
                              className="btn-b2b-b2c-fill btn-size"
                              style={{ color: "#ffffff" }}
                              bsStyle="info"
                              fill
                              onClick={this.addlead.bind(this)}
                            >
                              Add B2C <i className="fa fa-plus"></i>
                            </Button>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={2} sm={2} lg={2} xs={3} className="fl_mb_1">
                            <FormControl
                              style={{ position: "relative", top: "-5px" }}
                              name="name"
                              value={this.state.name || ""}
                              placeholder="Name"
                              onChange={this.onChange}
                              type="text"
                              className="text-input"
                            />
                          </Col>
                          <Col md={2} sm={2} lg={2} xs={2} className="fl_mb_1">
                            <FormControl
                              style={{ position: "relative", top: "-5px" }}
                              name="email"
                              value={this.state.email || ""}
                              placeholder="Email"
                              onChange={this.onChange}
                              type="text"
                              className="text-input"
                            />
                          </Col>
                          <Col md={2} sm={2} lg={2} xs={2} className="fl_mb_1">
                            <FormControl
                              style={{ position: "relative", top: "-5px" }}
                              name="mobile_no"
                              value={this.state.mobile_no}
                              placeholder="Mobile No"
                              onChange={this.onChange}
                              type="text"
                              className="text-input"
                            />
                          </Col>
                          <Col md={2} sm={2} lg={2} xs={2} className="fl_mb_1">
                            <Select
                              value={this.state.organization}
                              placeholder="Select Company"
                              options={this.state.organizationList}
                              onChange={(organization) => {
                                this.setState({
                                  organization,
                                  organization_id: organization
                                    ? organization.value
                                    : "",
                                });
                              }}
                              isClearable
                            />
                          </Col>
                          <Col md={2} sm={3} lg={2} xs={2} className="fl_mb_1">
                            <Button
                              fill
                              className="btn-b2b-b2c-fill btn-size"
                              style={{ color: "#ffffff" }}
                              bsStyle="info"
                              onClick={this.searchdata.bind(this)}
                            >
                              Filter
                            </Button>
                          </Col>
                          <Col md={2} sm={3} lg={2} xs={2} className="fl_mb_1">
                            <Button
                              fill
                              className="btn-b2b-b2c-fill btn-size"
                              style={{ color: "#ffffff" }}
                              bsStyle="info"
                              onClick={this.resetSearch.bind(this)}
                            >
                              Reset
                            </Button>
                          </Col>
                        </Row>
                      </div>

                      {/*
                      <Col md={12} sm={12} lg={12}  xs={12} >
                            
                        <Col md={3} sm={4} lg={3}  xs={12}>
                          
                        {this.state.statusdisplayid == "1" ? 
                            <Button className="fl_mb_1 btn-fill w_150" style={{'background':'hsl(360deg 100% 68%)','border-color':'hsl(360deg 100% 68%)' }} bsStyle="success" onClick={this.selectstatus.bind(this,'1')} fill >New</Button>
                            :
                            <Button className="fl_mb_1 btn-fill w_150"  bsStyle="success" onClick={this.selectstatus.bind(this,'1')} fill >New</Button>
                            }
                        </Col>
                        <Col md={3} sm={4} lg={3}  xs={12}>
                        {this.state.statusdisplayid == "2"?
                        <Button className="fl_mb_1 btn-fill w_150" style={{'background':'hsl(360deg 100% 68%)','border-color':'hsl(360deg 100% 68%)'}} bsStyle="success" onClick={this.selectstatus.bind(this,'2')} fill >
                            Negotiation
                            </Button>:
                            <Button className="fl_mb_1 btn-fill w_150"  bsStyle="success" onClick={this.selectstatus.bind(this,'2')} fill >
                            Negotiation
                            </Button>
                            }
                        </Col>
                        <Col md={3} sm={4} lg={3}  xs={12}>
                          {this.state.statusdisplayid == "3" ? 
                            <Button className="fl_mb_1 btn-fill w_150" style={{'background':'hsl(360deg 100% 68%)','border-color':'hsl(360deg 100% 68%)'}} bsStyle="success" onClick={this.selectstatus.bind(this,'3')} fill >
                            Subscribed
                            </Button>
                              :
                            <Button className="fl_mb_1 btn-fill w_150"  bsStyle="success" onClick={this.selectstatus.bind(this,'3')} fill >
                            Subscribed
                            </Button>
                          }
                        </Col>
                        <Col md={3} sm={4} lg={3}  xs={12} > 
                            {this.state.statusdisplayid == "4" ? 
                            <Button className="fl_mb_1 btn-fill w_150" style={{'background':'hsl(360deg 100% 68%)','border-color':'hsl(360deg 100% 68%)'}} bsStyle="" onClick={this.selectstatus.bind(this,'4')} fill >
                            Lost
                        </Button> : 
                            <Button className="fl_mb_1 btn-fill w_150"  bsStyle="success" onClick={this.selectstatus.bind(this,'4')} fill >
                                Lost
                            </Button>
                            }
                        </Col> 
                </Col>*/}
                    </Row>
                    <Row>
                      {statusdisplayid === "1" ||
                      statusdisplayid === "2" ||
                      statusdisplayid === "3" ||
                      statusdisplayid === "4" ? (
                        <Col md="12">
                          <br></br>
                          {/* <h5>{statusdisplayid === '1'? 'New Detail' : '' }
                    {statusdisplayid === '2' ? 'Negotiation Detail' : '' }
                    {statusdisplayid === '3' ? 'Subscribed Detail' : '' }
                    { statusdisplayid === '4' ? 'Lost Detail'  : '' } 
                    </h5> */}

                          <Table responsive>
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Package Name</th>
                                <th>Organization Name</th>
                                <th>Assigned Date</th>
                                <th>Mobile no</th>
                                <th>Is Donor</th>
                                <th>Comments</th>
                                {/* <th>Remaining Credits</th> */}
                                <th>User Trasaction</th>
                                {this.state.useraccess == 3 ? (
                                  ""
                                ) : (
                                  <th className="text-right">Actions</th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.loading ? (
                                <tr>
                                  <td colspan="10">
                                    <LoadingSpinner />
                                  </td>
                                </tr>
                              ) : this.state.noRecordFound ? (
                                <tr>
                                  <td colspan="10">
                                    <center>No record found</center>
                                  </td>
                                </tr>
                              ) : (
                                <React.Fragment>
                                  {lead_detail.map((cus) => (
                                    <tr>
                                      <td
                                        key={cus.id}
                                        style={{ textTransform: "capitalize" }}
                                      >
                                        {cus.name.toUpperCase()}
                                      </td>
                                      <td>{cus.email}</td>
                                      <td>
                                        <span>
                                          {" "}
                                          {this.getCusLeadCataloguePackageTitle(
                                            cus,
                                          )}
                                          {!!this.getAllPackageTitleRelatedLead(
                                            cus,
                                          ) && (
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={
                                                <Tooltip id="packageTitles">
                                                  {this.getAllPackageTitleRelatedLead(
                                                    cus,
                                                  )}
                                                </Tooltip>
                                              }
                                            >
                                              <Button
                                                style={{ border: "none" }}
                                              >
                                                <i className="fa fa-eye"></i>
                                              </Button>
                                            </OverlayTrigger>
                                          )}
                                        </span>
                                      </td>
                                      <td>
                                        {cus.b2b === null
                                          ? "-"
                                          : cus.b2b.company_name}
                                      </td>
                                      <td>{cus.updated_at}</td>
                                      <td>{cus.mobile_no}</td>
                                      <td>
                                        {cus.is_doner == 1 ? "Yes" : "No"}
                                      </td>
                                      <td>{cus.comments}</td>
                                      <td>
                                        <Button
                                          onClick={this.openusertrasactionmodal.bind(
                                            this,
                                            cus.id,
                                          )}
                                        >
                                          <i
                                            style={{ fontSize: "16px" }}
                                            className="fa fa-file-text"
                                          ></i>
                                        </Button>
                                      </td>
                                      {/* <td>{cus.earn_points != null? (cus.earn_points-0).toFixed(2)  : "0"}</td> */}
                                      {this.state.useraccess == 3 ? (
                                        ""
                                      ) : (
                                        <td className="td-actions text-right">
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={viewCallWorkspace}
                                          >
                                            <Link
                                              to={
                                                "/admin/lead/" +
                                                cus.id
                                              }
                                              className="btn btn-simple btn-info btn-xs"
                                              aria-label={
                                                "View call workspace profile for " +
                                                cus.name
                                              }
                                            >
                                              <i
                                                className="fa fa-eye"
                                                aria-hidden="true"
                                              />
                                            </Link>
                                          </OverlayTrigger>
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={edit}
                                          >
                                            <Button
                                              simple
                                              bsStyle="success"
                                              onClick={this.selectedlead.bind(
                                                this,
                                                cus.id,
                                              )}
                                              bsSize="xs"
                                            >
                                              <i className="fa fa-edit" />
                                            </Button>
                                          </OverlayTrigger>
                                          {/* <OverlayTrigger
                                            placement="top"
                                            overlay={remove}
                                          >
                                            <Button
                                              simple
                                              bsStyle="danger"
                                              onClick={this.warningWithConfirmAndCancelMessage.bind(
                                                this,
                                                cus.id
                                              )}
                                              bsSize="xs"
                                            >
                                              <i className="fa fa-times" />
                                            </Button>
                                          </OverlayTrigger> */}
                                        </td>
                                      )}
                                    </tr>
                                  ))}
                                </React.Fragment>
                              )}
                            </tbody>
                          </Table>
                          {this.state.loading ? (
                            ""
                          ) : this.state.noRecordFound ? (
                            ""
                          ) : (
                            <div style={{ textAlign: "center" }}>
                              <Pagination>
                                {!this.state.prevdisabled ? (
                                  <Pagination.First
                                    onClick={this.paginationinfo.bind(
                                      this,
                                      this.state.prevpage,
                                    )}
                                    disabled={this.state.prevdisabled}
                                  />
                                ) : (
                                  ""
                                )}
                                {this.state.paginationData.map((url) => (
                                  <Pagination.Item
                                    active={
                                      this.state.currentPage == c ? "1" : null
                                    }
                                    onClick={this.paginationinfo.bind(
                                      this,
                                      url,
                                      statusdisplayid,
                                    )}
                                  >
                                    {c++}
                                  </Pagination.Item>
                                ))}
                                {!this.state.nextdisabled ? (
                                  <Pagination.Last
                                    onClick={this.paginationinfo.bind(
                                      this,
                                      this.state.nextpage,
                                    )}
                                    disabled={this.state.nextdisabled}
                                  />
                                ) : (
                                  ""
                                )}
                              </Pagination>
                            </div>
                          )}
                        </Col>
                      ) : (
                        ""
                      )}
                    </Row>
                  </React.Fragment>
                }
              />
              <Modal
                className="custom-modal-style"
                bsSize="lg"
                show={this.state.usertrasactionmodal}
                aria-labelledby="example-modal-sizes-title-lg"
                onHide={() => this.setState({ usertrasactionmodal: true })}
              >
                <Modal.Header>
                  <Modal.Title>User Transaction List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Table style={{ overflowX: "scroll", display: "block" }}>
                    <thead>
                      <tr>
                        <th>#id</th>
                        <th>channel</th>
                        <th>credit</th>
                        <th>debit</th>
                        <th>Customer ID</th>
                        <th>Is From admin</th>
                        <th>noteTitle</th>
                        <th>created at</th>
                        <th>movedAndEarnDate</th>
                        <th>noteDescription</th>
                        <th>OrderId</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.usertrasactionmodalData.length == 0 ? (
                        <td colspan="10" style={{ textAlign: "center" }}>
                          <h5>No Data Found</h5>{" "}
                        </td>
                      ) : (
                        this.state.usertrasactionmodalData.map((u) => (
                          <tr>
                            <td>{u.id}</td>
                            <td>{u.channel}</td>
                            <td>{(u.credit - 0).toFixed(2)}</td>
                            <td>{(u.debit - 0).toFixed(2)}</td>
                            <td>{u.customerId}</td>
                            <td>{u.isFromAdmin ? "yes" : "no"}</td>
                            <td>{u.noteTitle != null ? u.noteTitle : "-"}</td>
                            <td>{u.createdAt}</td>
                            <td>{u.movedAndEarnDate}</td>
                            <td>
                              {u.noteDescription != null
                                ? u.noteDescription
                                : "-"}
                            </td>
                            <td>{u.orderId != null ? u.orderId : "-"}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    bsStyle="danger"
                    fill
                    onClick={this.closeusertrasactionmodal.bind(this)}
                  >
                    Cancel
                  </Button>
                </Modal.Footer>
              </Modal>
            </Col>
          </Row>
        </Grid>
        <Modal
          show={this.state.isAiaUserModel}
          onHide={() => this.setState({ isAiaUserModel: false })}
          bsSize="large"
          dialogClassName="aia-modal"
        >
          <Modal.Header>
            <Modal.Title>AIA User List</Modal.Title>
            <Col
              md={4}
              sm={4}
              lg={4}
              xs={4}
            >
              <FormControl
                name="aiaMobileNo"
                value={this.state.aiaMobileNo}
                placeholder="Mobile No"
                onChange={this.handleAiaMobileNoOnChange}
                type="text"
                className="text-input"
              />
            </Col>
            <Col md={2} sm={3} lg={2} xs={2} className="fl_mb_1">
              <Button
                fill
                className="btn-b2b-b2c-fill btn-size"
                style={{ color: "#ffffff", marginTop: "5px" }}
                bsStyle="info"
                onClick={this.resetSearchAiaMobile.bind(this)}
              >
                Reset
              </Button>
            </Col>
          </Modal.Header>
          <Modal.Body>
            <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
              <Table hover responsive>
                <thead>
                  <tr>
                    <th>Mobile No</th>
                    <th>User Active</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                  }}
                >
                  {this.state.aiaUserTransactionModalData.length == 0 ? (
                    <td colspan="10" style={{ textAlign: "center" }}>
                      <h5>No Data Found</h5>{" "}
                    </td>
                  ) : (
                    this.state.aiaUserTransactionModalData.map((item) => (
                      <tr>
                        <td>{item[0]}</td>
                        <td>{item[1].trim() === "Y" ? "yes" : "no"}</td>
                        <td>{item[2]}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} md={12} xs={12} className="text-right">
              <Button
                bsStyle="danger"
                fill
                onClick={() => this.setState({ isAiaUserModel: false })}
              >
                Cancel
              </Button>
            </Col>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default withRouter(viewLead);
